<template>
    <div class="block-categories__item-6-per-row category-card category-card--layout--classic">
        <div class="category-card__body">
            <div class="category-card__content">
                <div class="category-card__image image image--type--category">
                    <router-link :to="categoryDetails.category_url" class="image__body">
                        <img class="image__tag" :src="image_path" :alt="categoryDetails.name" />
                    </router-link>
                </div>

            </div>
            <div class="category-card__info-6-per-row">
                <div class="category-card__name">
                    <router-link :to="categoryDetails.category_url">{{categoryDetails.name}}</router-link>
                </div>
            </div>
        </div>
    </div> 
</template>

<script>
import CloudinaryApi from '../../../utilities/cloudinaryapi';
import Cloudinary from '../../../utilities/cloudinary';
import * as GCONST from '../../../constants.js';
import {scale} from "@cloudinary/base/actions/resize";
import axios from 'axios';

export default {
    data() {
        return {
            image_path: '',
        };
    },
    props: {
        index : {
            type: Number,
            required: true,
        },
        categoryDetails: { 
            type: Object,
            required: true
        }
    },
    methods: {
        async category_product() {
            const catCode = this.categoryDetails.DMCD01;
            
            this.$emit('clear_messages');
            this.parts = [];
            this.more_filters = [];
            this.isloading = true;

            let filter_uri = '';
            this.level = this.categoryDetails.level;
            let lvl = 1;
            while(lvl <= this.level){
                filter_uri += '&fq=DMCD0'+lvl+':' + this.categoryDetails['DMCD0' + lvl];
                lvl += 1;
            }

            filter_uri += '&fq=Image:[* TO *]';

            const solr_host = this.$store.getters.solr_hostname + '/solr/' + this.$store.getters.solr_coreadmin;
            let uri = solr_host + '/select?q.op=AND&q=DMCD01%3A'+catCode+'&facet.field=IGDESC&facet.field=MCNAME&facet=true&f.B2C_price.facet.range.start=0&f.B2C_price.facet.range.end=1000&f.B2C_price.facet.range.gap=100&facet.range=B2C_price&f.Weight.facet.range.start=0&f.Weight.facet.range.end=100&f.Weight.facet.range.gap=10&facet.range=Weight&group=true&group.field=Item&group.facet=true&group.format=simple&group.ngroups=true&sort=Image desc';
            let paginate_uri = '&rows=1&start=0';
            // const sorting_uri = '&sort=Stocks%20desc,%20Stocking_Flag%20desc';

            uri += filter_uri  + paginate_uri;
            // + this.facet_field_uri
            await axios.get(uri,{
                auth: {
                    username: this.$store.getters.solr_username,
                    password: this.$store.getters.solr_password
                }
            })
            .then((response) => {
                const parts = response.data.grouped.Item.doclist.docs;
                if(parts.length > 0){
                    if(parts[0].Image != '') {
                        this.image_path = parts[0].Image;
                    }else{
                        this.defaultImage();
                    }
                }else{
                    this.defaultImage();
                }

                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        defaultImage() {
            const cat1_images = this.$store.getters.cat_img_level_1.find(img => (img.DXCD01 == this.categoryDetails.DMCD01));
            if(cat1_images != undefined){
                const clImage = Cloudinary.image(cat1_images.publicId);
                clImage.resize(scale().width(GCONST.Category));
                this.image_path = clImage.toURL();
            }else{
                this.image_path = GCONST.IMAGE_PLACEHOLDER;
            }
        }
    },
    mounted() {
        const clApi = new CloudinaryApi;
        clApi.category_id = this.categoryDetails.DMCD01;
        clApi.category_2 = this.categoryDetails.DMCD02;
        
        clApi.vlImageByMeta(GCONST.CL_META_CATEGORY_ID, GCONST.Category).then(imgURL => {
            if(imgURL){
                this.image_path = imgURL;
            }else{
                // this.image_path = GCONST.IMAGE_PLACEHOLDER;
                this.category_product();
            }
        });
    }
}
</script>